module.exports = "<input name=\"file\" type=\"file\" custom-on-change='uploadFile' ng-required=\"{{ required }}\" />\n";